'use client';

interface ProgressBarProps {
  value: number;
  max: number;
  label?: string;
  showPercentage?: boolean;
  size?: 'sm' | 'md' | 'lg';
  color?: 'primary' | 'success' | 'warning' | 'danger';
}

export function ProgressBar({
  value,
  max,
  label,
  showPercentage = true,
  size = 'md',
  color = 'primary',
}: ProgressBarProps) {
  const percentage = Math.min(Math.round((value / max) * 100), 100);

  const sizes = {
    sm: 'h-1.5',
    md: 'h-2.5',
    lg: 'h-4',
  };

  const colors = {
    primary: 'bg-primary',
    success: 'bg-success',
    warning: 'bg-warning',
    danger: 'bg-danger',
  };

  // Auto-determine color based on percentage if color is primary
  const autoColor =
    color === 'primary'
      ? percentage >= 90
        ? 'bg-danger'
        : percentage >= 70
        ? 'bg-warning'
        : 'bg-primary'
      : colors[color];

  return (
    <div className="w-full">
      {(label || showPercentage) && (
        <div className="flex items-center justify-between mb-1.5">
          {label && (
            <span className="text-sm font-medium text-foreground">{label}</span>
          )}
          {showPercentage && (
            <span className="text-sm text-foreground-muted">{percentage}%</span>
          )}
        </div>
      )}
      <div
        className={`w-full bg-card-border rounded-full overflow-hidden ${sizes[size]}`}
      >
        <div
          className={`${autoColor} ${sizes[size]} rounded-full progress-bar`}
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
}

